import { SpartacuxProB2BAnimationState } from '@/domains/proB2BAnimation/store/proB2BAnimation.model';
import { proB2BAnimationSelector } from '@/domains/proB2BAnimation/store/proB2BAnimation.selectors';

export const eligibilityCoupon = (state: SpartacuxProB2BAnimationState) =>
  proB2BAnimationSelector(state)?.eligibilityCoupon;
